// src/components/cloudServices/PublicPanelCard.jsx
import React from 'react';
import { Card, CardContent, Typography, Button, Box } from '@mui/material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

export default function PublicPanelCard({ name, description, href }) {
  return (
    <Card
      sx={{
        minWidth: 320,
        minHeight: 180,
        m: 2,
        backgroundColor: '#2a2a2a',
        color: '#fff',
        pb: 1
      }}
      elevation={3}
    >
      <CardContent>
        <Typography variant="h6" gutterBottom>{name}</Typography>
        {description && (
          <Typography variant="body2" sx={{ color: '#ccc', mb: 2 }}>
            {description}
          </Typography>
        )}
        <Box>
          <Button
            variant="contained"
            endIcon={<OpenInNewIcon />}
            onClick={() => window.open(href, '_blank', 'noopener')}
          >
            Abrir painel
          </Button>
        </Box>
      </CardContent>
    </Card>
  );
}
